export const getLatestSavedRecord = (records = []) => {
	if (!Array.isArray(records) || records.length === 0) return null;
	return records.reduce((latest, current) => {
		if (!latest) return current;
		const latestId = Number(latest?.id || 0);
		const currentId = Number(current?.id || 0);
		return currentId >= latestId ? current : latest;
	}, null);
};
